export default "__VITE_ASSET__DyBCVM9d__"